import * as React from 'react';

const SvgFoodStand = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={54} height={54} fill="none" {...props}>
    <path
      d="M52.313 11.813H1.687l2.608-7.817a3.373 3.373 0 013.202-2.308h39.008c1.454 0 2.743.929 3.202 2.308l2.605 7.816zM18.563 11.813a8.438 8.438 0 01-16.875 0M35.438 11.813a8.438 8.438 0 01-16.876 0M52.313 11.813a8.438 8.438 0 01-16.876 0M18.563 1.688v10.124M35.438 1.688v10.124M5.063 18.563v33.75M48.938 18.563v33.75M1.688 35.438h50.624M13.5 42.188h10.125M15.188 52.313l3.374-10.126 3.375 10.126M32.063 42.188h10.124M33.75 52.313l3.375-10.126L40.5 52.313"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgFoodStand;
